// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Yu-z","breadcrumbForward":"Zu-z","breadcrumbBack":"_u-z","selected":"av-z"};